import React, { useEffect, useState } from 'react';
import * as _ from 'lodash';
import styles from './individualWorkPlan.module.css';
import { Pagination } from "../../assets/Pagination/Pagination";
import { Spinner } from 'react-bootstrap';
import NoData from '../../assets/NoData/NoData';
import Modal from 'react-modal';
import BookmarksOfIndividualWorkPlan from './BookmarksOfIndividualWorkPlan';
import { PDFDownloadLink } from '@react-pdf/renderer';
import IndividualWorkPlanPrintPdf from './PrintPdf';
import { getCurrentYear } from '../../utils/getItemFromRange';
import moment from 'moment';
import { IndividualWorkPlanContext } from '../../utils/context';
import { getIndividualPlanFilters } from '../../actions/individualWorkPlan';
import { useSelector } from 'react-redux';

const IndividualWorkPlan = ({
    fetchFacultyList,
    facultyList,
    pagesCount,
    isLoading,
    years = [],
    getYears,
    isJournalAdmin,
    getIndividualPlanIIITimes,
    getIndividualPlan,
    getIndividualPlanFilters,
    individualWorkPlanList,
    getIndividualPlanMain,
    getIndividualPlanI,
    getIndividualPlanII,
    getIndividualPlanIII,
    getIndividualPlanIIIGroup,

    individualWorkPlanById,
    individualWorkPlanTab,
    addIndividualPlanI,
    editIndividualPlanI,
    deleteIndividualPlanI,
    taskForYear,
    academicWork,
    academicWorkTimes,
    academicWorkGroup,
    editIndividualPlanIII,

    getCathList,
    list,
    filtersList,
    // PDF
    user,
    photo,
    error,
    layout,
    isTeacher,
    portfolio,
    group,
    gradebook,

    didMount,
    fetchGradebook,
    userId,
    // PDF
    scy,

    ...props
}) => {
    const [listYear, setListYear] = useState([])
    const [modal, setModal] = useState(null)
    const [photoDone, setPhotoDone] = useState(false)
    const [state, setState] = useState([]);
    const [tabIndex, setTabIndex] = useState(0)

    const {mid} = useSelector(state => state.auth)

    useEffect(() => {
        !!photo && setPhotoDone(photo)
        getYears()
        !!photo && didMount()
    }, [photo]);

    useEffect(() => {
        listYear && setState({ ...state, xp_key: getCurrentYear(listYear, moment())?.xp_key })
    }, [listYear]);

    const handleSelectorChange = (e) => {
        const { name, value } = e.target
        setState({ ...state, [name]: value })
    };

    useEffect(() => {  //set years and reverse 
        setListYear(years?.reverse())
    }, [years])

    useEffect(() => {
        if (!!modal) {
            const { id } = modal
            tabIndex == 1 && getIndividualPlanI(id)
            tabIndex == 2 && getIndividualPlanII(id) && getIndividualPlanIIITimes({ id, mid: mid, xp_key: state.xp_key })
            tabIndex == 3 && getIndividualPlanIII({ id, mid: mid, xp_key: state.xp_key }) && getIndividualPlanIIIGroup(id)
            tabIndex == 0 && getIndividualPlanMain(id)
        }
    }, [tabIndex, modal])

    useEffect(() => {
        state.xp_key && getIndividualPlanFilters(state.xp_key)
    }, [state.xp_key])

    useEffect(() => {
        !!state.faculty && getCathList(state.faculty)
    }, [state.faculty])

    const openModal = async (plan) => {
        await getIndividualPlanMain(plan.id)
        setModal(plan)
    }
    const renderEducationProgramsTable = (plan, index) => (
        <tr key={index} className="pointer" onClick={() => openModal(plan)}>
            <td>{plan["fio"]}</td>
            <td>{plan["position"]}</td>
            <td>{plan["academic_rank"]}</td>
        </tr>
    );

    const [flag, setflag] = useState(false) /// ШРИФТЫ НЕ УСПЕВАЮТ
    useEffect(() => {
        var timer = setTimeout(() => {
            setflag(true);
        }, 2000)
    }, [])

    const onRequestClose = () => {
        setModal(null)
        setTabIndex(0)
    }
    function groupBySort2(arr) {
        return arr?.reduce((acc, item) => {
            const par = item.parent;
            if (!acc[par]) acc[par] = [];
            acc[par].push(item);
            return acc;
        }, {});
    }
    function groupBySort3(arr) {
        return arr?.reduce((acc, item) => {
            const par = item.razdel;
            if (!acc[par]) acc[par] = [];
            acc[par].push(item);
            return acc;
        }, {});
    }
    // Применяем функцию к данным
    const filteredItemsYearBudget = groupBySort2(individualWorkPlanTab); // I
    const filteredItemsAcademicWork = groupBySort3(academicWork) || []; // III

    const contextValue = {
        id: !!modal && modal.id,
        tabIndex,
        setTabIndex,
        individualWorkPlanTab, // main
        taskForYear,
        addIndividualPlanI,
        editIndividualPlanI,
        deleteIndividualPlanI,
        filteredItemsYearBudget,
        filteredItemsAcademicWork,
        academicWorkGroup,
        editIndividualPlanIII,
        mid: !!modal && mid,
        xp_key: state.xp_key
    }

    const getPdf = () => {
        return (
            flag && !!layout.data &&
                <div style={{ margin: '1rem 0 0 auto', display: 'block', width: 'fit-content' }}>
                <PDFDownloadLink
                    document={
                        <IndividualWorkPlanPrintPdf
                            layoutData={layout}
                            user={user}
                            portfolio={portfolio}
                            group={group}
                            gradebook={gradebook}
                        />
                    }
                    fileName={`Индивидуальный план работы преподавателя на год.pdf`}>
                    {
                        ({ blob, url, loading, error }) => (loading ? 'Загрузка отчета...' :
                            <button className={styles.editButton}>Печать</button>
                        )}
                </PDFDownloadLink>
                </div>
        )
    }

    return (
        <div className="27jpg">
            <div className="captions">Индивидуальный план работы</div>
            <div className={styles.selectors}>
                <div className={styles.selectorsRight}>
                    <div>
                        <div style={{widows: '100%'}}>
                        <label>
                            Учебный год:
                        </label>
                        <select
                            style={{ width: '150px', paddingLeft: '1rem' }}
                            name='xp_key'
                            onChange={handleSelectorChange}
                            value={state.xp_key}
                        >
                            {listYear && listYear.length > 0 && listYear.map(c =>
                            (<option key={c.xp_key} value={c.xp_key}>
                                {c.name}
                            </option>))
                            }
                        </select>
                    </div>
                    <select
                            style={{width: '100%'}}
                            name='did'
                            onChange={handleSelectorChange}
                            value={state.did}
                        >
                            <option value='0'>Все</option>
                            {filtersList && filtersList.map(f => (
                                <option key={f.did} value={f.did}>
                                    {f.name}
                                </option>
                            ))
                            }
                        </select>
                    </div>

                    <button
                        style={{
                            margin: '0',
                            width: 'fit-content',
                            height: '35px',
                            padding: '0 2rem', 
                        }}
                        className={styles.updateButton}
                        onClick={() => getIndividualPlan(state)}
                    >Обновить</button>
                </div>
            </div>

            <Modal
                isOpen={!!modal}
                onRequestClose={onRequestClose}
                contentLabel="Modal"
            >
                <IndividualWorkPlanContext.Provider value={contextValue}>

                    <BookmarksOfIndividualWorkPlan
                        getPdf={getPdf}
                        id={!!modal && modal}
                        onRequestClose={onRequestClose}
                        tabIndex={tabIndex}
                        setTabIndex={setTabIndex}
                    />
                </IndividualWorkPlanContext.Provider>
            </Modal>

            <Pagination
                pageCount={pagesCount}
                numberPage={state.numberPage}
                onPageChange={(page) => setState({ ...state, numberPage: page.selected })}
            />

            {isLoading ? (
                <div className="text-center">
                    <br />
                    <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                </div>
            )
                : (individualWorkPlanList?.length ?
                    <table className="umkT-table mt-10">
                        <thead>
                            <tr>
                                <th>Фамилия Имя Отчество</th>
                                <th>Должность</th>
                                <th>Звание(уч.степень)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {individualWorkPlanList?.map(renderEducationProgramsTable)}
                        </tbody>
                    </table>
                    : <NoData text='данные отсутствуют' />
                )}
            <Pagination
                pageCount={pagesCount}
                numberPage={state.numberPage}
                onPageChange={(page) => setState({ ...state, numberPage: page.selected })}
            />
            {/* TODO пропало фото */}
            {/* {!!photoDone && */}
            

        </div>
    );
}


export default IndividualWorkPlan;